// extracted by mini-css-extract-plugin
export var wordContainer = "_rq-0";